import CommonIFrame from '../atoms/CommonIFrame';

const AssortmentPlanning = () => {
    return (
        <CommonIFrame
            src="https://assortment-and-basevolume.lovable.app/assortment-management/"
            title="Assortment Planning"
        />
    );
};

export default AssortmentPlanning;
